var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"steps-holder"},_vm._l((_vm.steps),function(step,i){return _c('div',{key:(step + "-" + i),staticClass:"steps-item",class:{
        'current-step': i + 1 === _vm.currentStep,
        'completed': _vm.currentStep > i + 1,
        'is-failed': step.isFailed
      }},[_c('button',{staticClass:"step",attrs:{"disabled":!step.isClickable},on:{"click":function($event){$event.preventDefault();return _vm.$emit('go-to-step', {
          step: step,
          index: i + 1,
        })}}},[_c('span',{staticClass:"step-circle"},[_vm._v(" "+_vm._s(i + 1)+" ")]),_c('span',{staticClass:"step-title"},[_vm._v(" "+_vm._s(step.stepLabel)+" ")])]),_c('div',{staticClass:"steps-separator"})])}),0),_c('claims-form-link',{staticClass:"row-claims-link"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }